export const mapInfusionClinicInfo = (response) => {
    return response?.data?.value?.resultItems;
};
export const mapSingleDataOfInfusionClinicPersonalInfo = (response) => {
    return response.value.resultItems;
};
